module.exports = __webpack_public_path__ + "static/media/check-green.deb4e2e6.png";